// Wrapper de label+input usado nos modais editaveis (ModalParcela e afins).
// Mantém o estilo canônico (label uppercase pequena em cima, input full-width).
import React from 'react';

export const CampoMP = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div>
    <label style={{ display: 'block', fontSize: 10, fontWeight: 600,
      color: '#555', textTransform: 'uppercase', letterSpacing: 0.5,
      marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);
